import React, { useContext } from "react";
import { MdArrowBack, MdOutlineClose } from "react-icons/md";
import { WidgetContext } from "../../../../contexts/widgetContext";
import { RouterContext } from "../../../../contexts/routerContext";
import { Container, Content, Buttons, CallInProgress } from "./styles";

const Header = ({
  children,
  buttonBack = true,
  buttonBackAction,
  buttonClose = true,
}) => {
  const { open, setOpen, callInProgress, timer, showReceivingCall } =
    useContext(WidgetContext);
  const { setRouter, router } = useContext(RouterContext);

  return (
    <Container>
      {callInProgress.status != "" &&
        router != "call-in-progress" &&
        !showReceivingCall && (
          <CallInProgress onClick={() => setRouter("call-in-progress")}>
            <strong>Em ligação, clique aqui para voltar</strong>
            <span>{timer}</span>
          </CallInProgress>
        )}
      {/*<Buttons>*/}
      {/*  {buttonBack ? (*/}
      {/*    <MdArrowBack*/}
      {/*      size={24}*/}
      {/*      color="#FFF"*/}
      {/*      cursor="pointer"*/}
      {/*      onClick={buttonBackAction}*/}
      {/*    />*/}
      {/*  ) : (*/}
      {/*    <div></div>*/}
      {/*  )}*/}
      {/*  {buttonClose ? (*/}
      {/*    <MdOutlineClose*/}
      {/*      size={24}*/}
      {/*      color="#FFF"*/}
      {/*      cursor="pointer"*/}
      {/*      onClick={() => setOpen(!open)}*/}
      {/*      style={{ zIndex: "11" }}*/}
      {/*    />*/}
      {/*  ) : (*/}
      {/*    <div></div>*/}
      {/*  )}*/}
      {/*</Buttons>*/}
      <Content>{children}</Content>
    </Container>
  );
};

export default Header;
